import styled, { ThemedStyledProps } from 'styled-components';
import { TTheme } from '@/styles/Themes/Theme.domain';
import { TParagraphProps } from './Paragraph.types';
import { fonts } from '@/styles/Themes/Fonts';

export const StyledParagraph = styled.p<ThemedStyledProps<TParagraphProps, TTheme>>`
    font: ${fonts.normal};
    text-align: 'center';
`;
